import { KeyOn } from '@tableau/vizportalclient-common-components';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { IPersonalAccessToken } from '../../ts/ServerApi/types/IPersonalAccessToken';
import { IServerUser } from '../../ts/ServerApi/types/IServerUser';
import { ServerUsers } from '../../userManagement/services/resources/ServerUsers';
import { UserSettingsStyle } from '../../userSettings/styles/UserSettingsStyle';
import { CreatePersonalAccessTokensSection } from './CreatePersonalAccessTokenSection';
import { ListPersonalAccessTokensSection } from './ListPersonalAccessTokenSection';

export interface PersonalAccessTokensSectionProps {
  canCreatePersonalAccessTokens: boolean;
  serverUser: IServerUser;
}

function PersonalAccessTokensSectionFC(props: PersonalAccessTokensSectionProps) {
  const [personalAccessTokens, setPersonalAccessTokens] = React.useState([] as IPersonalAccessToken[]);

  async function refreshPersonalAccessTokens(userId: string) {
    const tokens = await ServerUsers.instance.getPersonalAccessTokens(userId);
    setPersonalAccessTokens(tokens);
  }

  React.useEffect(() => {
    setPersonalAccessTokens([]);
    refreshPersonalAccessTokens(props.serverUser.id);
  }, [props.serverUser.id]);

  return (
    <table>
      <tbody>
        <tr>
          <td className={UserSettingsStyle.labelText}>
            {Messages.personalAccessTokenSection()}
          </td>
          <td className={UserSettingsStyle.detailsValue}>
            {Messages.personalAccessTokenDescription()}
          </td>
        </tr>
        {props.canCreatePersonalAccessTokens && <tr>
          <td className={UserSettingsStyle.labelText} />
          <td className={UserSettingsStyle.detailsValue}>
            <CreatePersonalAccessTokensSection
              personalAccessTokens={personalAccessTokens}
              refreshTokenList={() => refreshPersonalAccessTokens(props.serverUser.id)} />
          </td>
        </tr>}
        <tr>
          <td className={UserSettingsStyle.labelText} />
          <td className={UserSettingsStyle.detailsValue}>
            <ListPersonalAccessTokensSection
              serverUser={props.serverUser}
              personalAccessTokens={personalAccessTokens}
              refreshTokenList={refreshPersonalAccessTokens} />
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export const PersonalAccessTokensSection = KeyOn(
  PersonalAccessTokensSectionFC,
  (props: PersonalAccessTokensSectionProps) => props.serverUser.id);
